export const GetCoreImport = async (theme: string, name: string) => {
  if (theme == 'dark-default') {
    if (name == 'page.core') {
      return import('./dark-default/page.js')
    }
    if (name == 'devextreme.core') {
      return import('./dark-default/devextreme.js')
    }
    if (name == 'flexlayout.core') {
      return import('./dark-default/flexlayout.js')
    }
  }
  if (theme == 'light-default') {
    if (name == 'page.core') {
      return import('./light-default/page.js')
    }
    if (name == 'devextreme.core') {
      return import('./light-default/devextreme.js')
    }
    if (name == 'flexlayout.core') {
      return import('./light-default/flexlayout.js')
    }
  }
}
